module.exports = __webpack_public_path__ + "img/Logo_White.68f86b7f.svg";